import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
function Logout() {
    const navigate = useNavigate()
    const logoutUser = () => {
        axios.get('/api/v1/logouts')
            .then(function (response) {
                // handle success
                navigate('/')
            })
            .catch(function (error) {
                // handle error
                console.log(error);
                navigate('/')
            })

    }
    useEffect(() => {
        logoutUser()
    }, [])
    return (
        <div>
logout
        </div>
    )
}

export default Logout
